export default "__VITE_ASSET__2ae67bb8__"